import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AcquirerResponse } from '@/repositories/generated';

const response: AcquirerResponse[] = [
  {
    id: '1',
    name: 'モックアクワイアラ1',
  },
  {
    id: '2',
    name: 'モックアクワイアラ2',
  },
  {
    id: '3',
    name: 'モックアクワイアラ3',
  },
  {
    id: '71',
    name: 'モックアクワイアラ７',
  },
  {
    id: '81',
    name: 'モックアクワイアラ８',
  },
  {
    id: '111',
    name: 'モックアクワイアラ１１',
  },
  {
    id: '121',
    name: 'モックアクワイアラ１２',
  },
  {
    id: '131',
    name: 'モックアクワイアラ１３',
  },
  {
    id: '141',
    name: 'モックアクワイアラ１４',
  },
];

export const autocompleteAcquirer = http.get(
  createMockEndpoint('/autocomplete/acquirer'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
